import React, { useMemo, useState } from 'react';
import {
  Card, CardHeader, EmptyState, Table, Tabs,
} from '@opendate-app/setlist';
import {
  formatCount, formatPct, formatSignedPct, signedColor,
} from './bookingUtils';
import sortRows from './sortRows';

export const BREAKDOWN_TABS = [
  { value: 'venue', label: 'Venue' },
  { value: 'buyer', label: 'Talent buyer' },
  { value: 'creator', label: 'Created by' },
];
const NOUNS = { venue: 'venue', buyer: 'talent buyer', creator: 'creator' };
const COLUMN_HEADERS = { venue: 'Venue', buyer: 'Talent buyer', creator: 'Created by' };
const TOTAL_KEY = '__total';

function cell(row, content) {
  return row.id === TOTAL_KEY ? <strong>{content}</strong> : content;
}

function columns(by) {
  const num = (key, header, format = formatCount) => ({
    key, header, align: 'right', sortable: true, render: (row) => cell(row, format(row[key])),
  });
  const yoy = (key, header) => ({
    key,
    header,
    align: 'right',
    sortable: true,
    render: (row) => cell(row, <span style={{ color: signedColor(row[key]) }}>{formatSignedPct(row[key])}</span>),
  });
  return [
    { key: 'name', header: COLUMN_HEADERS[by], primary: true, sortable: true, render: (row) => cell(row, row.name) },
    num('holds', 'Holds'),
    num('offers', 'Offers'),
    num('confirms', 'Confirms'),
    num('hold_to_confirm_rate', 'Hold → confirm', formatPct),
    yoy('holds_yoy', 'Holds YoY'),
    yoy('offers_yoy', 'Offers YoY'),
    yoy('confirms_yoy', 'Confirms YoY'),
  ];
}

function BookingBreakdownCard({ data, loading, error, by, onByChange }) {
  const [sort, setSort] = useState({ key: 'confirms', direction: 'desc' });
  const rows = useMemo(() => {
    const sorted = sortRows(data?.rows || [], sort);
    return sorted.length && data?.total ? [...sorted, { ...data.total, id: TOTAL_KEY, name: 'Grand total' }] : sorted;
  }, [data, sort]);
  const noun = NOUNS[by];

  return (
    <Card
      padding="none"
      header={(
        <CardHeader
          title={`Performance by ${noun}`}
          supportingText="Volume and conversion side by side, with change vs last year."
          actions={<Tabs variant="button-border" size="sm" collapseBelow={0} items={BREAKDOWN_TABS} value={by} onChange={onByChange} />}
        />
      )}
    >
      <Table
        columns={columns(by)}
        data={rows}
        getRowKey={(row) => row.id}
        loading={loading}
        error={error}
        sort={sort}
        onSortChange={(key, direction) => setSort({ key, direction })}
        empty={<EmptyState title={`No ${noun} activity in this range`} description="Try a wider date range or fewer filters." />}
      />
    </Card>
  );
}

export default BookingBreakdownCard;
